const isProduction = process.env.NODE_ENV === 'production';

// Deployed backend URL
const developmentApiUrl = 'http://localhost:3000';
const productionApiUrl = ''; // Empty string means use the same domain (Vercel) which handles the rewrite

// Cognito Configuration
export const COGNITO_USER_POOL_ID = "us-west-2_27wTcltjf";
export const COGNITO_CLIENT_ID = "7j22vhqv27rnjvqelqe0r2vua3";

// Export the correct URL based on the environment
export const API_URL = isProduction ? productionApiUrl : developmentApiUrl; 